import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	warningMessage: {
		id: 'polaris-common.create-idea-dialog.leave-page-warning.warning-message',
		defaultMessage: 'We won’t be able to save your data if you move away from this page.',
		description: 'Description for confirmation modal dialog',
	},
});
